import { ChevronDown } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import transitions from './transitions.scss';

const ANIMATION_DURATION = 300;

const RotatingChevron = ({ isOpen, className }) => (
  <CSSTransition in={isOpen} timeout={ANIMATION_DURATION} classNames={{ ...transitions }}>
    <ChevronDown className={className} />
  </CSSTransition>
);

RotatingChevron.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default RotatingChevron;
